module.exports = __webpack_public_path__ + "img/icons BFr_23.cf774308.svg";